import React, { useMemo, useState } from 'react'
import { Breadcrumbs, InsideFooter } from '../../../../components'
import useHistory from '../../../../hooks/useHistory'
import useUrlParam from '../../../../hooks/useUrlParam'
import { BoxCertificate, BoxContainer, StatusText } from './styles'
import ecbrDNA from '../../../../assets/Icons/ecbrDna.svg'
import {
  CertificateStatusColors,
  getCertificateStatusText
} from '../../../../constants/certificate'
import { usePendingApprovalAnswersQuery } from '../hooks'
import { DefaultAdminPage } from '../../../DefaultPages'
import { Container, Top } from '../../styles'

const pagination = { page: 1, take: 10 }

const ReviewCertificates = () => {
  const history = useHistory()
  const [error, setError] = useState('')
  const [brandId] = useUrlParam('/admin/review/:id/certificates')
  const [searchParameters, _setSearchParameters] = useState({
    ...pagination
  })

  const {
    data: pendingApproval,
    isFetching,
    isLoading
  } = usePendingApprovalAnswersQuery(searchParameters, setError)

  // Gera a lista de certificados com base no array pendingApproval
  const { data: certificates } = useMemo(() => {
    const certificatesRepeated = pendingApproval
      ?.map(({ certificate }) => certificate)
      .filter((certificate) => certificate.brandId === Number(brandId))
    const certificatesUnique = certificatesRepeated?.reduce(
      (acc, certificate) => {
        if (!acc.find((c) => c.id === certificate.id)) {
          acc.push(certificate)
        }
        return acc
      },
      []
    )

    return {
      data: certificatesUnique
    }
  }, [brandId, pendingApproval])

  const handleClickCertificate = (certificateId) => {
    history.push(
      `/admin/review/${brandId}/certificates/${certificateId}/answers`
    )
  }

  return (
    <DefaultAdminPage page="revisao">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <h3>
          Aqui você pode gerenciar todas as certificações cadastradas na loja
        </h3>
        <BoxContainer>
          {isLoading && <p>Carregando...</p>}
          {!isFetching && !isLoading && !certificates?.length && (
            <p>Nenhum certificado encontrado</p>
          )}
          {error && <p>{error}</p>}
          {certificates?.map?.((certificate) => (
            <BoxCertificate
              key={certificate.id}
              onClick={() => handleClickCertificate(certificate.id)}
            >
              <div>
                <img src={ecbrDNA} alt="ecbrDNA" />
                <h3>{certificate.product?.name}</h3>
                <StatusText color={CertificateStatusColors[certificate.status]}>
                  {getCertificateStatusText(certificate.status)}
                </StatusText>
              </div>
            </BoxCertificate>
          ))}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default ReviewCertificates
